<table class="table table-sm table-hover">
  <thead>
    <tr>
      <th> Assets </th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    @for (asset of assets; track asset; let i = $index) {
      <tr>
        <td>{{asset.title}} </td>
        <td>
          <!-- <div class="pull-right"> <i (click)="gotoAsset(asset)" class="fa fa-chevron-right"></i></div> -->
        </td>
      </tr>
    }
  </tbody>
</table>
